function handleModals() {
  openModalBasedOnURLParam("#modal-location-form", "modalform");
  openModalBasedOnURLParam("#prMediaForm", "prMediaForm", () => {
    if ($(window).width() >= 768) {
      $("#prMediaForm").modal("show");
    } else {
      var navHeight = $(".navbar").height() + 40;
      $("html, body").animate({
        scrollTop: $("#collapse_pr-media").offset().top - navHeight,
      });
      $("#collapse_pr-media .collapse").collapse("show");
    }
  });
}

function openModalBasedOnURLParam(modalEl, param, customOpenFunc = null) {
  const url_string = window.location.href;
  const url = new URL(url_string);
  const formParam = url.searchParams.get(param);

  if (formParam && formParam === "open") {
    if (typeof customOpenFunc === "function") {
      customOpenFunc();
    } else {
      $(modalEl).modal("show");
    }
  }
}

export default handleModals;
